/** Zauberstab — „mit KI erstellen". Menüleiste „Creator" (28.09.2026, nach
 *  Marcels Vorlage: ein durchgehender Stab, drei Sterne in drei Größen). Stab
 *  als 2px-Linie mit runden Enden; die Sterne gefüllt mit eingezogenen Seiten
 *  — als Linie wären die kleinen Sterne bei 20px nicht mehr lesbar (kleine
 *  Füllungen sind im Symbolraster in Ordnung, vgl. Orbis Augen). Großer Stern
 *  oben rechts auf Höhe des mittleren (oben links), kleiner rechts zwischen
 *  großem Stern und Stabende — die beiden rechten sitzen bewusst hoch
 *  (Marcel: „die beiden rechten Sterne müssen hochrutschen", 3 Einheiten),
 *  und mittlerer und kleiner Stern sind um 20 % zum großen hin gerückt
 *  („enger zusammen"). Abstand der Sternspitzen zum großen Stern 1,3 / 1,4 —
 *  enger liefen sie im Menü zusammen.
 *  `viewBox` auf 24 um die Mitte der Zeichnung zugeschnitten: so steht sie
 *  gezeichnet ~21 groß wie die Nachbarn (in der 26er-Fläche waren es 19, und
 *  die schmalen Formen wirkten im Menü kleiner); der Stab wird dabei
 *  ~2,2px statt 2px — gewollt, wie in der Vorlage.
 *
 *  Nicht verwechseln mit `aiMagic` (älterer Zauberstab mit Querstrich, die
 *  Zeilenaktion „Agent-Einstellungen" in den Platzierungen). */
export const magicWandIcon = `
<svg width="100%" height="100%" viewBox="1.5 0.85 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.5 21.5L13 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
<path d="M18.8 3.6Q19.5 7.3 23.2 8Q19.5 8.7 18.8 12.4Q18.1 8.7 14.4 8Q18.1 7.3 18.8 3.6Z" fill="currentColor"/>
<path d="M10.96 3.8Q11.44 6.32 13.96 6.8Q11.44 7.28 10.96 9.8Q10.48 7.28 7.96 6.8Q10.48 6.32 10.96 3.8Z" fill="currentColor"/>
<path d="M20.16 12.8Q20.48 14.48 22.16 14.8Q20.48 15.12 20.16 16.8Q19.84 15.12 18.16 14.8Q19.84 14.48 20.16 12.8Z" fill="currentColor"/>
</svg>
`;
